import React from "react";
import PropTypes from "prop-types";

const OverdueSlipPreview = ({ selectedPatron, totalAmount }) => {
  const currentDate = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div id="overdue-slip-content">
      <div className="overdue-slip">
        <div className="slip-header">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "10px",
              gap: "15px",
            }}
          >
            <img
              src={`${process.env.REACT_APP_INVENIO_UI_URL}/api/static/images/lrc-logo.png`}
              alt="LRC Logo"
              style={{
                height: "60px",
                width: "auto",
                objectFit: "contain",
              }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
            <div style={{ textAlign: "center" }}>
              <div className="university-name">ROMBLON STATE UNIVERSITY</div>
            </div>
          </div>
        </div>

        <div className="slip-title">
          <div className="title-text">OVERDUE SLIP</div>
        </div>

        <div className="date-field">
          <strong>Date:</strong>{" "}
          <span className="underlined-field">{currentDate}</span>
        </div>

        <div className="name-field">
          <strong>NAME:</strong>{" "}
          <span className="underlined-field">{selectedPatron?.name || ""}</span>
        </div>

        <div className="amount-field">
          <strong>AMOUNT DUE:</strong>{" "}
          <span className="underlined-field"> ₱{totalAmount.toFixed(2)}</span>
        </div>

        <div className="signature-section">
          <div className="signature-line">____________________</div>
          <div className="signature-label">
            <strong>Librarian</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

OverdueSlipPreview.propTypes = {
  selectedPatron: PropTypes.object,
  totalAmount: PropTypes.number.isRequired,
};

OverdueSlipPreview.defaultProps = {
  selectedPatron: null,
};

export default OverdueSlipPreview;
